module.exports = __webpack_public_path__ + "media/Ondas.8d825271.mp4";